import React, { useState, useEffect } from 'react';
import { Wrapper, ClockWrapper } from './styles';
import { LogoutOutlined } from '@ant-design/icons';

const Clock = ({ signOut }) => {
    const [time, setTime] = useState(new Date().toLocaleTimeString());

    useEffect(() => {
        const updateTime = () => {
            setTime(new Date().toLocaleTimeString());
        };

        const intervalId = setInterval(updateTime, 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    return <Wrapper>
        <ClockWrapper>
            {time}
        </ClockWrapper>
        <div
            style={{
                cursor: 'pointer',
                fontSize: 16,
            }}
            onClick={() => signOut()}>
            <LogoutOutlined />
        </div>
        <div>Powered by Grittek ltd</div>
    </Wrapper >;
};

export default Clock;